import React, {useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {
    updateTemplateHTMLMessage,
    updateTemplateMessages,
    updateTemplatePlainTextMessage
} from "../../../../../actions";
import {Button, CircularProgress, DialogActions, IconButton} from "@mui/material";
import {Dialog, DialogContent, DialogTitle} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import CloseIcon from "@material-ui/icons/Close";
import BBIconEdit from "../../../../../assets/bbCustomIcons/BBIconEdit";

const UpdateTemplateMessages = ({templateId=null, currentValue=null})=>{

    const {templates, updatingTemplate} = useSelector(({admin})=>admin);
    const template = templates && templateId && templates.templates && templates.templates[templateId];

    const dispatch = useDispatch();

    const [open, setOpen] = useState(false);
    const [newHTMLMessage, setNewHTMLMessage] = useState(null);
    const [newPlainTextMessage, setNewPlainTextMessage] = useState(null);

    const handleSubmit = () =>{

        if(newHTMLMessage && !newPlainTextMessage){
            console.log("Submitting these values", templateId, newHTMLMessage);
            dispatch(updateTemplateHTMLMessage(templateId, newHTMLMessage));
        } else if(newPlainTextMessage && !newHTMLMessage){
            console.log("Submitting these values", templateId, newPlainTextMessage);
            dispatch(updateTemplatePlainTextMessage(templateId, newPlainTextMessage))
        } else if (newPlainTextMessage && newHTMLMessage){
            console.log("Submitting these values", templateId, newPlainTextMessage, newHTMLMessage);
            dispatch(updateTemplateMessages(templateId, newHTMLMessage, newPlainTextMessage));

        }


        setOpen(false);
    }

    return(
        <div>
            {!updatingTemplate
                ? <span className={"m-0 p-0 d-inline"}>
                    {currentValue ? currentValue : "--"}&nbsp;
                    <IconButton onClick={()=>setOpen(true)} className={"m-0 p-0 d-inline"}>
                    <BBIconEdit style={{fontSize: "1rem"}} />
                </IconButton>
                </span>
                : <CircularProgress/>}


            {open && templateId &&
            <Dialog open={open}
                    fullScreen={false}
                    fullWidth={true}
                    maxWidth={"lg"}
                    className={"m-1 p-1 animated fadeIn animation-duration-6"}
                    aria-labelledby="form-dialog-title">

                <DialogTitle id="customized-dialog-title" >
                    <Row>
                        <Col lg={11}/>
                        <Col lg={1} className={"text-right align-self-center d-print-none"}>
                            <IconButton
                                onClick={()=>setOpen(false)}
                                className={"close"}>
                                <CloseIcon/>
                            </IconButton>
                        </Col>
                    </Row>
                </DialogTitle>
                <DialogContent style={{minHeight:"300px"}}>

                    <Row >
                        <Col>
                            <p>Plaintext:</p>
                             <textarea className={"form-control"}
                                            name={"plainTextMessage"}
                                            id={"plainTextMessage"}
                                            rows={4}
                                            defaultValue={template && template.plaintext_message ? template.plaintext_message : "...."}
                                            // placeholder={template && template.plaintext_message ? template.plaintext_message : "...."}
                                            onChange={(e)=>setNewPlainTextMessage(e.target.value)}
                                />
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <br/>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <p>HTML:</p>
                           <textarea className={"form-control"}
                                            name={"htmlMessage"}
                                            id={"htmlMessage"}
                                             rows={4}
                                            defaultValue={template && template.html_message ? template.html_message : "...."}
                                            // placeholder={template && template.html_message ? template.html_message : "...."}
                                            onChange={(e)=>setNewHTMLMessage(e.target.value)}
                                />
                        </Col>
                    </Row>
                </DialogContent>

                <DialogActions>
                    <Col lg={12}>
                        <Button onClick={()=>setOpen(false)}
                                variant="contained" color="primary"
                                style={{float: "right"}}>
                            Cancel
                        </Button>
                        <Button
                            className={"float-right"}
                            variant="contained" color="primary"
                            type={"submit"}
                            onClick={()=>handleSubmit()}
                        >
                            Submit
                        </Button>

                    </Col>
                </DialogActions>
            </Dialog>
            }
        </div>
    )

}

export default UpdateTemplateMessages;